/*
Author : Arman Ali
Module: Zone
github: https://github.com/Arman-Arzoo
*/
import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import apiInstanceV2 from '../../Apis/AxiosV2';
import { DEVICE_SERVICE, IMAGE_SERVICE, STATUS_SERVICE, ZONE_SERVICE } from './../EndPoints';
import { UploadImage } from '../ShareSlice/shareApi';


// List all the father zones ( pagination) (done)
export const GetListFatherZones = createAsyncThunk(
    'employeeZones/getListFatherZones',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(ZONE_SERVICE.getListFatherZones, params?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// display all the status in the dropdown (done)
export const GetListStatusZone = createAsyncThunk(
    'employeeZones/getListStatusZone',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(STATUS_SERVICE.getListStatusZone)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Create Father Zone (done)
export const CreateFatherZone = createAsyncThunk(
    'employeeZones/createFatherZone',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(ZONE_SERVICE.createFatherZone, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Create Child Zone (done)
export const CreateChildZone = createAsyncThunk(
    'employeeZones/createChildZone',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(ZONE_SERVICE.createChildZone, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Retrieve the information (Zone Detail) Details Common Area Sub Zones Total Access Devices and the list ( company-module zone-controller) (done)
export const ZoneDetailFatherAndChild = createAsyncThunk(
    'employeeZones/zoneDetailFatherAndChild',
    async (params) => {
        const { zoneId } = params;
        const result = await apiInstance
            .post(`${ZONE_SERVICE.zoneDetailFatherAndChild}${zoneId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const ZoneDetailSummary = createAsyncThunk(
    'employeeZones/zoneDetailSummary',
    async (params) => {
        const { zoneId } = params;
        const result = await apiInstance
            .post(`${ZONE_SERVICE.zoneDetailSummary}${zoneId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Retrieve the information (Zone Detail) Details Common Area Sub Zones Total Access Devices and the list ( company-module zone-controller) (done)
export const ZoneDetailChildV1 = createAsyncThunk(
    'employeeZones/zoneDetailChildV1',
    async (params, { dispatch, getState }) => {
        const { zoneId } = params;
        const result = await apiInstance
            .get(`${ZONE_SERVICE.zoneDetailChildV1}${zoneId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Retrieve the information (Zone Detail Child) Details and FatherZone
export const ZoneDetailChild = createAsyncThunk(
    'employeeZones/zoneDetailChild',
    async (params, { dispatch, getState }) => {
        const { zoneId } = params;
        const result = await apiInstance
            .get(`${ZONE_SERVICE.zoneDetailChild}${zoneId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Retrieve the information (Zone Detail) Autorized Employees (done)
export const ZoneDetailAuthorizedEmployee = createAsyncThunk(
    'employeeZones/zoneDetailAuthorizedEmployee',
    async (params, { dispatch, getState }) => {
        const { zoneId } = params;
        const result = await apiInstance
            .post(`${ZONE_SERVICE.zoneDetailAuthorizedEmployee}${zoneId}`, params?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// without pagination
export const ZoneDetailAuthorizedEmployeeNoPagination = createAsyncThunk(
    'employeeZones/zoneDetailAuthorizedEmployeeNoPagination',
    async (param, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${ZONE_SERVICE.zoneDetailAuthorizedEmployeeNoPagination}${param}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Retrieve the information (Zone Detail) List of devices (done)
export const ZoneDetailListDevice = createAsyncThunk(
    'employeeZones/zoneDetailListDevice',
    async (params, { dispatch, getState }) => {
        const { zoneId } = params;
        const result = await apiInstance
            .get(`${ZONE_SERVICE.zoneDetailListDevice}${zoneId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update zone /update company-module zone-controller (done)

export const UpdateZone = createAsyncThunk('employeeZones/updateZone', async (params, { dispatch, getState }) => {
    const result = await apiInstance.put(ZONE_SERVICE.updateZone, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// common-area/create company-module zone-controller (done)
export const CreateCommonAreaZone = createAsyncThunk(
    'employeeZones/createCommonAreaZone',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(ZONE_SERVICE.createCommonAreaZone, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// common-area/update company-module zone-controller (done)
export const UpdateCommonAreaZone = createAsyncThunk(
    'employeeZones/updateCommonAreaZone',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(ZONE_SERVICE.updateCommonAreaZone, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// access-type/get-all company-module device-controller
export const GetAccessType = createAsyncThunk('employeeZones/getAccessType', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .get(DEVICE_SERVICE.getAccessType)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// device-type/get-all company-module device-controller

export const GetDeviceType = createAsyncThunk('employeeZones/getDeviceType', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .get(DEVICE_SERVICE.getDeviceType)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// create device in Zone /create company-module device-controller

export const CreateDeviceZone = createAsyncThunk(
    'employeeZones/createDeviceZone',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(DEVICE_SERVICE.createDeviceZone, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// create device smartlock in Zone /create company-module device-controller

export const CreateDeviceSmartlock = createAsyncThunk(
    'employeeZones/createDeviceSmartlock',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(DEVICE_SERVICE.createDeviceSmartlock, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// get device in Zone /get company-module device-controller

export const GetDeviceZone = createAsyncThunk('employeeZones/getDeviceZone', async (id, { dispatch, getState }) => {
    const result = await apiInstance
        .get(`${DEVICE_SERVICE.getDeviceZone}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// get device smartlock in Zone /get company-module device-controller

export const GetDeviceSmartlock = createAsyncThunk(
    'employeeZones/getDeviceSmartlock',
    async (id, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`device-service/smart-lock/get-by-device-id/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// delete device smartlock in Zone /delete company-module device-controller

export const DeleteDevice = createAsyncThunk('employeeZones/deleteDevice', async (id, { dispatch, getState }) => {
    const result = await apiInstance
        .put(`${DEVICE_SERVICE.deleteDevice}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// update device in Zone /update company-module device-controller

export const UpdateDeviceZone = createAsyncThunk(
    'employeeZones/updateDeviceZone',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(DEVICE_SERVICE.updateDeviceZone, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update device smartlock in Zone /update company-module device-controller

export const UpdateDeviceSmartlock = createAsyncThunk(
    'employeeZones/updateDeviceSmartlock',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(DEVICE_SERVICE.updateDeviceSmartlock, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Call API, remove the user /user-zone/delete-by-user-id/{userId}/by-zone-id/{zoneId} company-module zone-controller

export const DeleteZoneUser = createAsyncThunk(
    'employeeZones/deleteZoneUser',
    async (params, { dispatch, getState }) => {
        const { userIds, zoneId } = params;
        const result = await apiInstance
            .post(`${ZONE_SERVICE.deleteZoneUser}${zoneId}`, userIds)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Create list with user zone relationships

export const CreateUserZoneList = createAsyncThunk(
    'employeeZones/createUserZoneList',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(ZONE_SERVICE.createUserZoneList, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// display all the zone map in the dropdown (done)
export const GetListZoneMap = createAsyncThunk(
    'employeeZones/getListZoneMap',
    async (params, { dispatch, getState }) => {
        const { zoneId } = params;
        const result = await apiInstance
            .get(`${ZONE_SERVICE.zoneDetailListDevice}${zoneId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// zone-plane/create company-module zone-controller (done)
export const CreateZonePlane = createAsyncThunk(
    'employeeZones/createZonePlane',
    async (params, { dispatch, getState }) => {
        const { name, zone, file, option } = params;

        const result = await apiInstance
            .post(ZONE_SERVICE.createZonePlane, { name, zone })
            .then(function (response) {
                const formData = new FormData();
                formData.append('id', response?.data?.data?.id);
                formData.append('option', 'zone');
                formData.append('file', file);
                dispatch(UploadImage(formData));

                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// set-coordinates company-module device-controller
export const SetZoneImageCoordinate = createAsyncThunk(
    'employeeZones/setZoneImageCoordinate',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(DEVICE_SERVICE.setZoneImageCoordinate, params?.data)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// device-server/zone-plane/get-all/by-zone-plane-id/{zonePlaneId}

export const GetZoneDevicesLists = createAsyncThunk(
    'employeeZones/getZoneDevicesLists',
    async (params, { dispatch, getState }) => {
        const { zonePlaneId } = params;
        const result = await apiInstance
            .get(`${DEVICE_SERVICE.getZoneDevicesLists}${zonePlaneId}`, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
